/**
 * Decodes a data: URL into raw bytes without using fetch().
 *
 * The app's CSP (`connect-src`) does not allow data: URLs, so fetch()ing
 * them is blocked by the browser — decode in memory instead. Handles both
 * base64 and percent-encoded payloads.
 */
export function dataUrlToBytes(url: string): Uint8Array<ArrayBuffer> {
  const comma = url.indexOf(",");
  if (!url.startsWith("data:") || comma === -1) {
    throw new Error("Invalid data URL");
  }

  const meta = url.slice(0, comma);
  const payload = url.slice(comma + 1);

  if (meta.toLowerCase().endsWith(";base64")) {
    const binary = atob(payload);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  }

  return new TextEncoder().encode(decodeURIComponent(payload));
}
